import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';

type BugReportLinkResponse = {
  form_url?: string;
  url?: string;
};

@Injectable({
  providedIn: 'root'
})
export class BugReportService {
  private readonly http = inject(HttpClient);
  private readonly env = environment;

  getPrefilledLink(coId: string): Observable<string> {
    const url = `${this.env.API_URL}/feedback/bug-report/prefill-link`;
    return this.http.post<BugReportLinkResponse>(url, { coId }).pipe(
      map((response) => this.extractFormUrl(response))
    );
  }

  getGeneralLink(): Observable<string> {
    const url = `${this.env.API_URL}/feedback/bug-report/general-link`;
    return this.http.get<BugReportLinkResponse>(url).pipe(
      map((response) => this.extractFormUrl(response))
    );
  }

  private extractFormUrl(response: BugReportLinkResponse): string {
    const formUrl = response.form_url ?? response.url;
    if (!formUrl) {
      throw new Error('Missing bug report form URL');
    }
    return formUrl;
  }
}
